import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import SendIcon from "@mui/icons-material/Send";

import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import FacebookIcon from "@mui/icons-material/Facebook";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { Fragment } from "react";
import { Card } from "@mui/material";

const Contractme = () => {
  return (
    <Fragment>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
     
      
            <Grid sx={{ xs: 12, md: 12 }}>
              <Typography
                gutterBottom
                variant="div"
                sx={{
                  mr: 2,
                  display: { md: "flex" },
                  fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
                  fontWeight: "bold",
                  textAlign: "justify",
                  color: "#2b5aa0",
                  marginTop: 2,
                  //color: "white",
                  textDecoration: "none",
                  //background:"#373e46"
                  fontSize: { xs: 14, md: 18, lg: 22 },
                }}
              >
                <h1>Contactanos por:</h1>
              </Typography>
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                }}
              >
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <WhatsAppIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <a
                    style={{ textDecoration: "none", color: "green" }}
                    href="https://wa.me/527471771277?text=Hola%20necesito%20ayuda"
                  >
                    <ListItemText color="#2b5aa0" primary="Whatsapp" />
                  </a>
                </ListItem>

                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AlternateEmailIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <a
                    style={{ textDecoration: "none", color: "secondary" }}
                    href="mailto:redcompsoporte@gmail.com"
                  >
                    <ListItemText
                      color="#2b5aa0"
                      primary="redcompsoporte@gmail.com"
                    />
                  </a>
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <PhoneCallbackIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <a
                    style={{ textDecoration: "none", color: "primary" }}
                    href="tel:+527471771277"
                  >
                    <ListItemText color="#2b5aa0" primary="Telefono" />
                  </a>
                </ListItem>
              </List>
            </Grid>
        {/*     <Grid size={{ xs: 12, md: 6 }}>
              <Container>
                <Typography
                  gutterBottom
                  variant="p"
                  sx={{
                    mr: 2,
                    display: { md: "flex" },
                    fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
                    fontWeight: "bold",
                    textAlign: "justify",
                    color: "#2b5aa0",
                    marginTop: 2,
                    //color: "white",
                    textDecoration: "none",
                    //background:"#373e46"
                    fontSize: { xs: 14, md: 18, lg: 22 },
                  }}
                >
                  <h1>Contactanos</h1>
                </Typography>
                <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-amount">
                    Nombre:
                  </InputLabel>
                  <Input id="name" name="name" />
                </FormControl>
                <FormControl
                  sx={{ m: 1, width: { md: "45%" } }}
                  variant="standard"
                >
                  <TextField
                    label="Correo Electronico:"
                    id="email"
                    sx={{ m: 1 }}
                    variant="standard"
                  />
                </FormControl>
                <FormControl
                  sx={{ m: 1, width: { md: "47%" } }}
                  variant="standard"
                >
                  <TextField
                    label="Telefono:"
                    id="phone"
                    sx={{ m: 1 }}
                    variant="standard"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-amount">
                    Mensaje:
                  </InputLabel>
                  <Input
                    id="msg"
                    name="msg"
                    multiline
                    rows={4}
                    variant="standard"
                  />
                </FormControl>
                <FormControl sx={{ m: 1 }} variant="standard">
                  <Button
                    variant="contained"
                    size="medium"
                    color="success"
                    endIcon={<SendIcon />}
                  >
                    Enviar
                  </Button>
                </FormControl>
              </Container>
            </Grid> */}
        
      
      </Box>
    </Fragment>
  );
};
export default Contractme;
